<script>
  export let error;
</script>

<style>
  * {
    text-align: center;
  }
  div {
    padding: 2rem;
  }
  h3 {
    color: #ebcb8b;
  }
  code {
    color: #bf616a;
  }
</style>

<div>
  <h3>Oops, sorry about that.</h3>
  <code>{error}</code>
</div>
